import { useEffect, useState } from 'react';
import PageMarkup from '../../common/PageMarkup';
import AutomatedTemplates from './Automated/AutomatedTemplates';
import ExtensionTemplates from './ExtensionTemplates/Templates';
import CustomTemplates from './CustomTemplates/CustomTemplates';
import AutomatedPromotionalTemplates from './AutomatedPromotional';
import { useLocation } from 'react-router-dom';
import { getWabaDetailsbyShopId, loadWabaDetails } from '../../redux/actions/private-waba';
import { PLAN_ENTERPRISE, TUTORIAL_VIDEOS } from '../../constants/constants';
import { getTeamInboxStatus } from '../../redux/actions/teamInbox';
import { fetchPhoneSettings } from '../../redux/actions/crmOrders';

const CommonTemplates = ( {privateWabaDetails, selectedTabForTemplate, showPricingBanner} : any) => {

  const [selectedTab, setSelectedTab] = useState(selectedTabForTemplate);
  const shop = JSON.parse(localStorage.getItem('shop') || '{}');
  const currentPlanId = JSON.parse(localStorage.getItem('currentPlan') || '{}');
  const location: any = useLocation();
  const [pvtWabaDetails, setPvtWabaDetails]: any = useState(privateWabaDetails);
  const [teamInboxDone, setTeamInboxDone] = useState(false);
  const [phoneData, setPhoneData]= useState({countryCode: '', phone: '' });
  const [optinEnterpriseTemplatesEnabled, setOptinEnterpriseTemplatesEnabled] = useState(false);

  useEffect(() => {
    // if (location?.state?.tab === 'ct' && pvtWabaDetails) {
    //   setSelectedTab(2);
    // } else if (location?.state?.tab === 'et') {
    //   let tabId = pvtWabaDetails ? 3 : 2;
    //   setSelectedTab(tabId);
    // }
    if (!privateWabaDetails) {
      getEmbeddedWabaDetails();
    }
    // if(location?.state?.from === "enableFeatures"){
    //   setSelectedTab(3);
    // }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    getTeamInboxStatus(shop.userId).then((res : any) => {
      if(res?.data?.status === 'ACCOUNT_LIVE'){
        setTeamInboxDone(true);
      }
      else{
        setTeamInboxDone(false);
      }
    });
    fetchPhoneSettings(shop.userId).then((res: any) => {
      if (res.status === 'success') {
        setPhoneData(res.settings);
      }
    });
  }, []);
  
  useEffect(()=>{
    checkOptinEnterpriseTemplates();
  },[teamInboxDone, pvtWabaDetails, phoneData])

  const getEmbeddedWabaDetails = () => {
    let shop = JSON.parse(localStorage.getItem('shop') || '{}');
    if (shop && shop.userId) {
      loadWabaDetails(shop.userId).then((res: any) => {
        if (res && res.appId && res.whatsappVerificationStatus) {
          setPvtWabaDetails(res);
        } else {
          getWabaDetailsbyShopId(shop.id).then((res: any) => {
            if (res && res.appId && res.whatsappVerificationStatus) {
              setPvtWabaDetails(res);
            }
          });
        }
      });
    }
  };

  const checkSupportNoSameAsWabaNo = () => {
    let phone ;
    if(pvtWabaDetails && phoneData.hasOwnProperty('countryCode')){
      if(pvtWabaDetails.hasOwnProperty("number")){
        phone = pvtWabaDetails.number ;
      }
      else if(pvtWabaDetails.hasOwnProperty("wabaNumber")){
        phone = pvtWabaDetails.wabaNumber ;
      }
      return Number(phoneData.countryCode.concat(phoneData.phone)) === Number(phone) ? true : false ;
    }
    else {
      return false ;
    }
  }

  // Check whether user is on Enterprise Plan , has Agent Assist setup and uses WABA number as support number
  const checkOptinEnterpriseTemplates = () => {
    if(currentPlanId===PLAN_ENTERPRISE && teamInboxDone && checkSupportNoSameAsWabaNo()){
      setOptinEnterpriseTemplatesEnabled(true);
    }
    else{
      setOptinEnterpriseTemplatesEnabled(false);
    }
  }

  const tabs = [
    {
      id: 'Automated',
      content: 'Order Automation',
      accessibilityLabel: 'Order Automation',
      panelID: 'automated',
    },
    {
      id: 'Automated Promotional',
      content: 'Promotion Automation',
      accessibilityLabel: 'Promotion Automation',
      panelID: 'automatedPromotional',
    },
    // {
    //   id: 'Custom Templates',
    //   content: 'Custom Templates',
    //   accessibilityLabel: 'Custom Templates',
    //   panelID: 'customTemplates',
    // },
    // {
    //   id: 'Extension Templates',
    //   content: 'Extension Templates',
    //   accessibilityLabel: 'Extension Templates',
    //   panelID: 'extensionTemplates',
    // },
  ];

  const tabContent = {
    0: <AutomatedTemplates optinEnterpriseTemplates={optinEnterpriseTemplatesEnabled}></AutomatedTemplates>,
    1: <AutomatedPromotionalTemplates optinEnterpriseTemplates={optinEnterpriseTemplatesEnabled} ></AutomatedPromotionalTemplates>,
    // 2: <CustomTemplates privateWabaDetails={pvtWabaDetails}></CustomTemplates>,
    // 3: <ExtensionTemplates ></ExtensionTemplates>,
  };

  return (
    <>
      <PageMarkup
        title='Automation'
        tutorial
        tutorialSrc={TUTORIAL_VIDEOS.AUTOMATION_PAGE.videoSrc}
        tutorialTitle={TUTORIAL_VIDEOS.AUTOMATION_PAGE.content}
        tabs={tabs}
        tabContent={tabContent}
        selected={selectedTab}
      ></PageMarkup>
    </>
  );
};
export default CommonTemplates;
